var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      staticClass: "report-dashboard open-shifts-dashboard py-0",
      attrs: { fluid: "" }
    },
    [
      _c("DashboardFilters", { on: { input: _vm.setCriteria } }),
      _c("v-progress-linear", {
        attrs: { active: _vm.loading, color: "secondary", indeterminate: "" }
      }),
      _vm.dashboard
        ? _c(
            "div",
            {
              staticClass: "dashboard-content",
              style: { height: _vm.contentHeight }
            },
            [
              _c("div", { staticClass: "section-title" }, [
                _vm._v(
                  "\n      " + _vm._s(_vm.$t("labels.coverage")) + "\n    "
                )
              ]),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                _vm._l(_vm.coverageTiles, function(tile) {
                  return _c(
                    "v-col",
                    { key: tile.key, attrs: { cols: "6", md: "3" } },
                    [
                      _c("DashboardTile", {
                        class: tile.key,
                        attrs: {
                          detail: tile.detail,
                          label: tile.label,
                          value: tile.value
                        }
                      })
                    ],
                    1
                  )
                }),
                1
              ),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "8" } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "chart-card", attrs: { outlined: "" } },
                        [
                          _c("div", { staticClass: "chart-title" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("labels.openingsPerDay")) +
                                "\n          "
                            )
                          ]),
                          _c("BarChart", {
                            attrs: {
                              "chart-data": _vm.openingsPerDayData,
                              options: _vm.stackedBarOptions,
                              styles: _vm.chartStyles
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "4" } },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "chart-card origins",
                          attrs: { outlined: "" }
                        },
                        [
                          _c("div", { staticClass: "chart-title" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("labels.openingsByOrigin")) +
                                "\n          "
                            )
                          ]),
                          _vm.dashboard.openings > 0
                            ? _c("DoughnutChart", {
                                attrs: {
                                  "chart-data": _vm.originsData,
                                  options: _vm.doughnutOptions,
                                  styles: _vm.chartStyles
                                }
                              })
                            : _c(
                                "div",
                                {
                                  staticClass: "no-data grey--text",
                                  style: _vm.chartStyles
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.$t("labels.noRecords")) +
                                      "\n          "
                                  )
                                ]
                              )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "chart-card", attrs: { outlined: "" } },
                        [
                          _c(
                            "div",
                            { staticClass: "d-flex align-center" },
                            [
                              _c("div", { staticClass: "chart-title" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("labels.coverageBy")) +
                                    "\n            "
                                )
                              ]),
                              _c("v-spacer"),
                              _c(
                                "v-btn-toggle",
                                {
                                  staticClass: "breakdown",
                                  attrs: {
                                    color: "secondary",
                                    dense: "",
                                    mandatory: ""
                                  },
                                  model: {
                                    value: _vm.breakdown,
                                    callback: function($$v) {
                                      _vm.breakdown = $$v
                                    },
                                    expression: "breakdown"
                                  }
                                },
                                _vm._l(_vm.breakdownOptions, function(option) {
                                  return _c(
                                    "v-btn",
                                    {
                                      key: option.value,
                                      attrs: {
                                        small: "",
                                        text: "",
                                        value: option.value
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(option.text) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _c("HorizontalBarChart", {
                            attrs: {
                              "chart-data": _vm.breakdownData,
                              options: _vm.horizontalStackedBarOptions,
                              styles: _vm.barChartStyles(
                                _vm.breakdownRows.length
                              )
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("div", { staticClass: "section-title" }, [
                _vm._v("\n      " + _vm._s(_vm.$t("labels.speed")) + "\n    ")
              ]),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _vm._l(_vm.speedTiles, function(tile) {
                    return _c(
                      "v-col",
                      { key: tile.key, attrs: { cols: "6", md: "3" } },
                      [
                        _c("DashboardTile", {
                          class: tile.key,
                          attrs: {
                            detail: tile.detail,
                            label: tile.label,
                            value: tile.value
                          }
                        })
                      ],
                      1
                    )
                  }),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6" } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "chart-card", attrs: { outlined: "" } },
                        [
                          _c("div", { staticClass: "chart-title" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t("labels.medianTimeToFillByMethod")
                                ) +
                                "\n          "
                            )
                          ]),
                          _c("BarChart", {
                            attrs: {
                              "chart-data": _vm.fillMethodsData,
                              options: _vm.barOptions,
                              styles: _vm.chartStyles
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                2
              ),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "chart-card", attrs: { outlined: "" } },
                        [
                          _c("div", { staticClass: "chart-title" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t("labels.coverageByPostingLeadTime")
                                ) +
                                "\n          "
                            )
                          ]),
                          _c("BarChart", {
                            attrs: {
                              "chart-data": _vm.leadTimeData,
                              options: _vm.stackedBarOptions,
                              styles: _vm.chartStyles
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("div", { staticClass: "section-title" }, [
                _vm._v("\n      " + _vm._s(_vm.$t("labels.demand")) + "\n    ")
              ]),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _vm._l(_vm.demandTiles, function(tile) {
                    return _c(
                      "v-col",
                      { key: tile.key, attrs: { cols: "6", md: "3" } },
                      [
                        _c("DashboardTile", {
                          class: tile.key,
                          attrs: {
                            detail: tile.detail,
                            label: tile.label,
                            value: tile.value
                          }
                        })
                      ],
                      1
                    )
                  }),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6" } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "chart-card", attrs: { outlined: "" } },
                        [
                          _c("div", { staticClass: "chart-title" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("labels.bidsPerOpenShift")) +
                                "\n          "
                            )
                          ]),
                          _c("BarChart", {
                            attrs: {
                              "chart-data": _vm.bidsDistributionData,
                              options: _vm.barOptions,
                              styles: _vm.chartStyles
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                2
              ),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6" } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "chart-card", attrs: { outlined: "" } },
                        [
                          _c("div", { staticClass: "chart-title" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("labels.mostPickedUp")) +
                                "\n          "
                            )
                          ]),
                          _c(
                            "v-simple-table",
                            {
                              staticClass: "top-pickups",
                              attrs: { dense: "" }
                            },
                            [
                              _c("thead", [
                                _c("tr", [
                                  _c("th", [
                                    _vm._v(
                                      _vm._s(_vm.$t("labels.employeeName"))
                                    )
                                  ]),
                                  _c("th", [
                                    _vm._v(
                                      _vm._s(_vm.$t("labels.homeDepartment"))
                                    )
                                  ]),
                                  _c("th", { staticClass: "text-right" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.$t("labels.shifts")) +
                                        "\n                "
                                    )
                                  ]),
                                  _c("th", { staticClass: "text-right" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.$t("labels.hours")) +
                                        "\n                "
                                    )
                                  ]),
                                  _c("th", { staticClass: "text-right" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.$t("labels.bids")) +
                                        "\n                "
                                    )
                                  ])
                                ])
                              ]),
                              _c(
                                "tbody",
                                [
                                  _vm._l(_vm.dashboard.topPickups, function(
                                    row
                                  ) {
                                    return _c("tr", { key: row.userId }, [
                                      _c("td", [_vm._v(_vm._s(row.name))]),
                                      _c("td", [
                                        _vm._v(_vm._s(row.homeDepartmentName))
                                      ]),
                                      _c("td", { staticClass: "text-right" }, [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.formatNumber(row.shifts)
                                            ) +
                                            "\n                "
                                        )
                                      ]),
                                      _c("td", { staticClass: "text-right" }, [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.formatNumber(row.hours)
                                            ) +
                                            "\n                "
                                        )
                                      ]),
                                      _c("td", { staticClass: "text-right" }, [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.formatNumber(row.bids)) +
                                            "\n                "
                                        )
                                      ])
                                    ])
                                  }),
                                  _vm.dashboard.topPickups.length === 0
                                    ? _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass: "grey--text",
                                            attrs: { colspan: "5" }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.$t("labels.noPickups")
                                                ) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      ])
                                    : _vm._e()
                                ],
                                2
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6" } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "chart-card", attrs: { outlined: "" } },
                        [
                          _c("div", { staticClass: "chart-title" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("labels.mostBids")) +
                                "\n          "
                            )
                          ]),
                          _c(
                            "v-simple-table",
                            {
                              staticClass: "top-bidders",
                              attrs: { dense: "" }
                            },
                            [
                              _c("thead", [
                                _c("tr", [
                                  _c("th", [
                                    _vm._v(
                                      _vm._s(_vm.$t("labels.employeeName"))
                                    )
                                  ]),
                                  _c("th", [
                                    _vm._v(
                                      _vm._s(_vm.$t("labels.homeDepartment"))
                                    )
                                  ]),
                                  _c("th", { staticClass: "text-right" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.$t("labels.bids")) +
                                        "\n                "
                                    )
                                  ]),
                                  _c("th", { staticClass: "text-right" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.$t("labels.pickedUp")) +
                                        "\n                "
                                    )
                                  ])
                                ])
                              ]),
                              _c(
                                "tbody",
                                [
                                  _vm._l(_vm.dashboard.topBidders, function(
                                    row
                                  ) {
                                    return _c("tr", { key: row.userId }, [
                                      _c("td", [_vm._v(_vm._s(row.name))]),
                                      _c("td", [
                                        _vm._v(_vm._s(row.homeDepartmentName))
                                      ]),
                                      _c("td", { staticClass: "text-right" }, [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.formatNumber(row.bids)) +
                                            "\n                "
                                        )
                                      ]),
                                      _c("td", { staticClass: "text-right" }, [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.formatNumber(row.pickedUp)
                                            ) +
                                            "\n                "
                                        )
                                      ])
                                    ])
                                  }),
                                  _vm.dashboard.topBidders.length === 0
                                    ? _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass: "grey--text",
                                            attrs: { colspan: "4" }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.$t("labels.noBids")
                                                ) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      ])
                                    : _vm._e()
                                ],
                                2
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }